/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Credit_Packs_TitleInputs */

const en_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top up anytime`)
};

const de_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit aufladen`)
};

const fr_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechargez a tout moment`)
};

const es_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarga en cualquier momento`)
};

const it_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricarica in qualsiasi momento`)
};

const nl_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op elk moment opwaarderen`)
};

const pl_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doladuj w kazdej chwili`)
};

const fi_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa milloin tahansa`)
};

const da_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyld op nar som helst`)
};

const sv_pricing_credit_packs_title = /** @type {(inputs: Pricing_Credit_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyll pa nar som helst`)
};

/**
* | output |
* | --- |
* | "Top up anytime" |
*
* @param {Pricing_Credit_Packs_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_credit_packs_title = /** @type {((inputs?: Pricing_Credit_Packs_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Credit_Packs_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_credit_packs_title(inputs)
	if (locale === "fr") return fr_pricing_credit_packs_title(inputs)
	if (locale === "es") return es_pricing_credit_packs_title(inputs)
	if (locale === "it") return it_pricing_credit_packs_title(inputs)
	if (locale === "nl") return nl_pricing_credit_packs_title(inputs)
	if (locale === "pl") return pl_pricing_credit_packs_title(inputs)
	if (locale === "fi") return fi_pricing_credit_packs_title(inputs)
	if (locale === "da") return da_pricing_credit_packs_title(inputs)
	if (locale === "sv") return sv_pricing_credit_packs_title(inputs)
	return en_pricing_credit_packs_title(inputs)
});